import { SKILLSETS_ACCESSOR, SKILLSET_IDS_ACCESSOR } from '@common/abilities/shared';
import { VIRTUAL_PROPS_ACCESSOR } from '@core/shared/virtual-properties';
/**
 * unfortunately needed to solve circularity issue between UserItem and CompanyItem.
 * (in some production scenarios, design:type will cause a circular situation. Funny thing it works in some situations!)
 */
export class CompanyInterface {}